// extracted by mini-css-extract-plugin
export default {"storyCard":"StoryCard_storyCard__Hqbbo"};